module.exports = __webpack_public_path__ + "img/all-light.2944e17c.svg";